import store from "@/store"
import { consts } from "@/store/constants"

export class Metrics {
  static humanizeMetricValue(metric, value) {
    try {
      if (metric.input_type === "Currency") {
        const symbol = this.getCurrencyByValue(metric.input_options.currency)?.symbol || "$"
        let number_formatted = ""
        if (metric.input_options.truncate) {
          number_formatted = this.truncateNumber(Number(value)).toLocaleString()
        } else {
          number_formatted = this.formatAsCurrency(Number(value)).toLocaleString()
        }
        return symbol + number_formatted
      } else if (metric.input_type === "Percent") {
        if (Number(value) < 1) {
          return this.truncateNumber(Number(value) * 100).toLocaleString() + "%"
        } else {
          return this.truncateNumber(Number(value)).toLocaleString() + "%"
        }
      } else if (metric.input_type === "Number") {
        if (metric.input_options.truncate) {
          return this.truncateNumber(Math.floor(Number(value)))
        } else {
          return this.formatAsCurrency(Number(value)).toLocaleString()
        }
      } else if (metric.input_type === "Decimal") {
        return this.formatAsCurrency(Number(value), parseInt(metric.input_options.decimal_places)).toLocaleString()
      } else {
        return value
      }
    } catch {
      return value
    }
  }
  static parseMetricValue(metric, value) {
    if (isNaN(value)) {
      return value
    } else {
      if (Number(value) > 500) {
        return "$" + this.truncateNumber(Number(value)).toLocaleString()
      } else {
        if (
          metric.name.toLowerCase().search("rate") != -1 ||
          metric.name.toLowerCase().search("%") != -1 ||
          metric.name.toLowerCase().search("percentage") != -1
        ) {
          return Number(value).toLocaleString() + "%"
        } else {
          return Number(value).toLocaleString()
        }
      }
    }
  }

  static getMetricById = (id) => {
    if (id) {
      return store.state.metrics.find((m) => m.id == id)
    }
    return id
  }

  static calculateRecordMetricColor = (id, value) => {
    let return_obj = null
    if (id) {
      const metric_colors = store.state.metrics.find((m) => m.id == id)?.metric_colors
      if (metric_colors?.ranges) {
        metric_colors.ranges.forEach((range) => {
          if (parseInt(value) >= parseInt(range[1]) && parseInt(value) <= parseInt(range[2])) {
            return_obj = {
              color: range[0],
              option: metric_colors.metric_color_display_option,
              is_primary_metric_color: metric_colors.is_primary_metric_color
            }
          }
          if (!range[2] && parseInt(value) >= parseInt(range[1])) {
            return_obj = {
              color: range[0],
              option: metric_colors.metric_color_display_option,
              is_primary_metric_color: metric_colors.is_primary_metric_color
            }
          }
        })

        return return_obj
      }
    }
    return return_obj
  }
  static getMetricByReferenceName = (ref) => {
    if (ref) {
      let parent_filters = [
        {
          type: "field",
          data_type: "String",
          input_type: "Text",
          name: "Origin",
          display: "Origin",
          id: "origins",
          reference_name: "origins",
          value: "origins",
          label: "Origin",
          options: []
        },
        {
          object_type: "record",
          id: "parent__id",
          reference_name: "parent__id",
          value: "parent__id",
          label: "Parent",
          options: [],
          type: "field",
          name: "Parent",
          display: "Parent",
          data_type: "String",
          input_type: "Text"
        },
        {
          object_type: "record",
          id: "top_parent",
          reference_name: "top_parent",
          value: "top_parent",
          label: "Top Parent",
          options: [],
          type: "field",
          name: "Top Parent",
          display: "Top Parent",
          data_type: "String",
          input_type: "Text"
        },
        {
          object_type: "record",
          id: "owner__id",
          reference_name: "owner__id",
          value: "owner__id",
          label: "Owner",
          options: [],
          type: "field",
          name: "Owner",
          display: "Owner",
          data_type: "String",
          input_type: "Text"
        },
        {
          object_type: "record",
          id: "co_owners__id",
          reference_name: "co_owners__id",
          value: "co_owners__id",
          label: "Co-Owners",
          options: [],
          type: "field",
          name: "Co-Owners",
          display: "Co-Owners",
          data_type: "List",
          input_type: "Text"
        },
        {
          object_type: "record",
          id: "tags__name",
          reference_name: "tags__name",
          value: "tags__name",
          label: "Assigned Tags",
          options: [],
          type: "field",
          name: "Assigned Tags",
          display: "Assigned Tags",
          data_type: "List",
          input_type: "Text"
        }
      ]
      return store.state.metrics.concat(parent_filters).find((m) => m.reference_name == ref)
    }
    return ref
  }
  static getObjectTypeByType = (typ, strict = false) => {
    let object_type = store.state.object_types.find((m) => m.type == typ)
    if (strict && !object_type) {
      return null
    }
    return object_type || typ
  }
  static getCurrencyByValue = (value) => {
    return consts.currencies[value]
  }
  static getMetricNameById = (id, metrics = []) => {
    try {
      if (id) {
        if (metrics.length > 0) {
          if (typeof metrics[0] != "string") {
            return metrics.filter((m) => m.id == id)[0].name
          }
        }
        return store.state.metrics.filter((m) => m.id == id)[0].name
      }
      return id
    } catch (error) {
      return id
    }
  }
  static getObjectTypeById = (id) => {
    return store.state.object_types.find((m) => m.id == id)
  }
  static getDomainName = (url) => {
    try {
      let domain = new URL(url)
      return domain?.hostname.replace("www.", "") || url
    } catch (error) {
      return url
    }
  }
  static getOptionMetricReference(object_type, option = "name", returned_field = "reference_name", return_default = true) {
    let option_metric = this.getMetricById(
      store.state.integration.platform_metric_mappings.find((m) => m.option == option && m.object_type == object_type)?.metric
    )
    if (!option_metric) {
      option_metric = store.state.integration.metrics_mapping[object_type + "_" + option + "_metric"]
    }
    if (!option_metric) {
      if (return_default) {
        let metric_ref = object_type + "_" + option
        if (returned_field == "id") {
          let resp = store.state.metrics.filter(
            (m) => m.data_type == "String" && m.object_type == object_type && m.reference_name.includes(metric_ref)
          )[0]
          if (resp) {
            return resp.id
          } else {
            return store.state.metrics.filter((m) => m.data_type == "String" && m.object_type == object_type)[0].id
          }
        } else {
          return metric_ref
        }
      } else {
        return ""
      }
    }
    if (returned_field) {
      return option_metric[returned_field]
    } else {
      return option_metric
    }
  }
  static getRecordLogoUrl = (record) => {
    if (!record) {
      return window.default_company
    }
    let website = Metrics.getDomainName(record.values[Metrics.getOptionMetricReference(record.type, "website")])
    return `https://logosnap.io/api/${website}?token=ecoTB81m5dQqkrjw`
  }
  static getUserById = (id, attr = null) => {
    let user_id = id
    if (typeof id != "string") {
      user_id = id?.id
    }
    let user = store.state.data.users.find((m) => m?.id == user_id)
    if (attr && user) {
      return user[attr]
    }
    return user
  }
  static getUserByOriginId = (origin_id, origin, attr = null) => {
    let user_id = origin_id
    if (typeof origin_id != "string") {
      user_id = origin_id.origins[origin]
    }
    let user = store.state.data.users.find((m) => Object.values(m.origins).includes(user_id))
    if (attr && user) {
      return user[attr]
    }
    return user
  }
}
